import Modal from '../../../components/ui/Modal';
import Button from '../../../components/ui/Button';
import { SessionSummaryModal } from './SessionSummaryModal';
import EmailReportModal from '../../../components/reports/EmailReportModal';
import AddAssetModal from '../../../components/AddAssetModal';

/**
 * The session-level dialogs that live outside the scrollable content: the
 * cancel-session confirmation, the finish-session summary, the email-report
 * modal, and the add-asset modal. Pure presentational wiring extracted verbatim
 * from TestSessionView; all state and side effects stay with the caller.
 */
export function SessionModals({
  // Cancel confirmation
  showCancelConfirm,
  isCancelling,
  onCloseCancel,
  onConfirmCancel,
  // Finish summary
  showFinishSessionModal,
  sessionResults,
  sessionAssets,
  onCloseFinish,
  onCompleteFinish,
  isFinishing,
  onExportPdf,
  onExportDefectReport,
  onEmailSessionReport,
  onEmailDefectReport,
  canExport,
  isSyncing,
  // Email report
  emailModalOpen,
  emailReportType,
  onCloseEmail,
  defaultRecipient,
  onSendEmail,
  // Add asset
  showAddAssetModal,
  siteId,
  siteDisplayName,
  elementType,
  sessionAssetType,
  onAddAssetSuccess,
  onCloseAddAsset,
}) {
  return (
    <>
      <Modal
        isOpen={showCancelConfirm}
        onClose={onCloseCancel}
        title="Cancel Session?"
        style={{ maxWidth: '420px' }}
      >
        <p style={{ margin: '12px 0 20px' }}>
          This will permanently delete all recorded tests in this session. Affected assets will be
          restored to their previous compliance state.
        </p>
        <p style={{ marginBottom: '20px', color: 'var(--danger)', fontWeight: 500 }}>
          This cannot be undone.
        </p>
        <div className="modal-actions">
          <Button
            type="button"
            variant="secondary"
            onClick={onCloseCancel}
            disabled={isCancelling}
          >
            Keep Testing
          </Button>
          <Button
            type="button"
            variant="danger"
            disabled={isCancelling}
            onClick={onConfirmCancel}
          >
            {isCancelling ? 'Cancelling…' : 'Cancel Session'}
          </Button>
        </div>
      </Modal>

      {showFinishSessionModal && (
        <SessionSummaryModal
          sessionResults={sessionResults}
          sessionAssets={sessionAssets}
          onClose={onCloseFinish}
          onComplete={onCompleteFinish}
          isFinishing={isFinishing}
          onExportPdf={onExportPdf}
          onExportDefectReport={onExportDefectReport}
          onEmailSessionReport={onEmailSessionReport}
          onEmailDefectReport={onEmailDefectReport}
          canExport={canExport}
          isSyncing={isSyncing}
        />
      )}
      <EmailReportModal
        isOpen={emailModalOpen}
        onClose={onCloseEmail}
        reportTypeLabel={
          emailReportType === 'defect' ? 'Defect Report' : 'Session Report'
        }
        defaultRecipient={defaultRecipient}
        onSend={onSendEmail}
      />
      {showAddAssetModal && (
        <AddAssetModal
          siteId={siteId}
          siteDisplayName={siteDisplayName}
          elementType={elementType}
          sessionAssetType={sessionAssetType}
          onSuccess={onAddAssetSuccess}
          onClose={onCloseAddAsset}
        />
      )}
    </>
  );
}
